module.exports = __webpack_public_path__ + "static/media/R1.3ec3a91c.jpg";